import { ComboDataDTO } from '../ComboDataDTO'

export interface ServiceBossDTO {
  serviceBossDateId: number | null
  professional: ComboDataDTO | null
  professionalName: string
  dateBegin: Date | null
  dateEnd: Date | null
}

export interface ServiceListItemDTO {
  serviceId: number
  externalCode: string
  serviceName: string
  currentBossName: string
  active: boolean
}

export interface ServiceDetailDTO {
  serviceId: number
  externalCode: string
  serviceName: string
  active: boolean
  bosses: ServiceBossDTO[]
}

export interface ServiceBossSaveDTO {
  serviceBossDateId?: number | null
  professionalId: number
  dateBegin: string
  dateEnd?: string | null
}

export interface ServiceSaveDTO {
  serviceId?: number | null
  externalCode: string
  serviceName: string
  active: boolean
  bosses: ServiceBossSaveDTO[]
  bossIdsToDelete: number[]
}

export interface ServicesListQueryParams {
  activeFilter?: boolean[]
  multiSortMeta?: unknown
  filterDTO?: unknown
  cardFilterDTO?: unknown
}

export const defaultServiceBossDTO: ServiceBossDTO = {
  serviceBossDateId: null,
  professional: null,
  professionalName: '',
  dateBegin: null,
  dateEnd: null,
}

export const defaultServiceDetailDTO: ServiceDetailDTO = {
  serviceId: -1,
  externalCode: '',
  serviceName: '',
  active: true,
  bosses: [],
}
